import { Component, OnInit, ViewEncapsulation, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalService } from '../global.service';
import * as M from "materialize-css/dist/js/materialize";

@Component({
	selector: 'unos-izmjena-sifrarnik',
	templateUrl: './unos-izmjena-sifrarnik.component.html',
	styleUrls: ['./unos-izmjena-sifrarnik.component.css']
})
export class UnosIzmjenaSifarnikComponent implements OnInit {
	@Input() id;
	@Input() nazivSifrarnika;
	@Input() idParent;

	@Output() onInsertStavka = new EventEmitter<any>();
	@Output() onCancel = new EventEmitter<any>();

	constructor(private http: HttpClient, public globalSrvc: GlobalService) { }
	loading = false;
	msg : any;
	naziv : any = null; 
	
	err_naziv = false;
	err_naziv_poruka = '';

	ngOnInit() {
		this.ucitaj();
	}

	server_data : any = null;

	ucitaj() {		
	}

	toastTimeout = 5000;

	cancel(){
		if (this.onCancel)
			this.onCancel.emit(null);
	}

	savedata(){
		//console.log('this.naziv', this.naziv);

		if (!this.naziv) {
			this.err_naziv = true;
			this.err_naziv_poruka = 'Morate definisati polje Naziv.';
			M.toast({html: this.err_naziv_poruka, displayLength : this.toastTimeout});
			return;
		}

		let url = 'vlasnici/sifrarnik/dodaj';
		/*if (this.id){
			url = 'vlasnici/pravno/izmijeni';
		}*/

		this.loading = true;
		let obj = {id : null, naziv : this.naziv, nazivSifrarnika : this.nazivSifrarnika, idParent : this.idParent};
		//console.log(obj);

		setTimeout(() => {				
		
			this.http.post(url, obj)
				.subscribe(data => {
					this.msg = data;
					//console.log(data);
					this.loading = false;

					if (this.msg.id == 1) {
						if (this.msg.newId) obj.id = this.msg.newId + '';

						if (this.onInsertStavka)
							this.onInsertStavka.emit(obj);
					}
					else {
						//this.globalSrvc.showErrorModal(this.msg.text);
						M.toast({html:this.msg.text, displayLength : this.toastTimeout});
					}
					this.naziv = '';
				}
				, error => {
					this.loading = false;
					//this.globalSrvc.showGenericErrorModal();
				}
			);
		}, 1000);
	}

}
